/* Welding spark cursor effect.
   Skipped on touch-only devices and when the user prefers reduced motion. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(pointer: fine)');

  if (reducedMotion.matches || !finePointer.matches) return;

  var SPARK_CHANCE = 0.05;
  var MAX_SPARKS = 24;
  var activeSparks = 0;

  function createSpark(x, y) {
    if (activeSparks >= MAX_SPARKS) return;

    var spark = document.createElement('div');
    spark.className = 'welding-spark';
    spark.setAttribute('aria-hidden', 'true');
    spark.style.left = x + 'px';
    spark.style.top = y + 'px';

    var destinationX = (Math.random() - 0.5) * 100;
    var destinationY = (Math.random() - 0.5) * 100;

    document.body.appendChild(spark);
    activeSparks += 1;

    var animation = spark.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + destinationX + 'px, ' + destinationY + 'px) scale(0)', opacity: 0 },
      ],
      {
        duration: 500 + Math.random() * 500,
        easing: 'cubic-bezier(0, 0.9, 0.57, 1)',
      }
    );

    animation.onfinish = function () {
      spark.remove();
      activeSparks -= 1;
    };
  }

  document.addEventListener('mousemove', function (event) {
    if (Math.random() < SPARK_CHANCE) {
      createSpark(event.pageX, event.pageY);
    }
  });
})();
